import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { Helps } from './libs/helps';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  @Output() route = new EventEmitter<any>();
  title = 'admin';
  currentRoute: string;

  constructor(
    private router: Router,
    private helps: Helps
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("ROUTE", event.url);
        this.currentRoute = event.url;
        this.route.emit(this.currentRoute);
      }
    });
  }
  ngOnInit() {
    // Request notification permissions
    this.requestNotificationPermission();
  }

  private requestNotificationPermission(): void {
    // This will be handled by the global panic alert service after login
    console.log('🔔 Permisos de notificación se solicitarán después del login');
  }
}
